import React from 'react';
import { Avatar, Chip, InternalStandardProps } from '@mui/material';
import { ChipProps } from '@mui/material/Chip';
import uuidv4 from 'uuid/v4';
import { parsePathToArray, parsePathToString } from '../../../crud-core/utils/Path';
import { useStyles } from './styles';

export const DEFAULT_PATH_TO_LABEL = 'label';
export const DEFAULT_PATH_TO_VALUE = 'value';

export type ChipsFieldProps = {
  chipProps?: ChipProps;
  defaultAvatar?: JSX.Element;
  field: string;
  item?: Object;
  label?: string;
  onClick?: (value: string) => void;
  onDelete?: (value: string) => void;
  pathToAvatar?: string;
  pathToLabel?: string;
  pathToValue?: string;
} & InternalStandardProps<React.HTMLAttributes<HTMLDivElement>>;

const ChipsField: React.FC<ChipsFieldProps> = ({
  chipProps,
  defaultAvatar,
  field,
  item = {},
  onClick,
  onDelete,
  pathToAvatar,
  pathToLabel = DEFAULT_PATH_TO_LABEL,
  pathToValue = DEFAULT_PATH_TO_VALUE,
}: ChipsFieldProps) => {
  const classes = useStyles();
  const chipItems = parsePathToArray(field, item, null);

  if (!Array.isArray(chipItems)) {
    return null;
  }
  return (
    <>
      {chipItems.map((chipItem) => {
        const label = parsePathToString(pathToLabel, chipItem, chipItem);
        const value = parsePathToString(pathToValue, chipItem, chipItem);
        const avatarUrl = parsePathToString(pathToAvatar, chipItem, null);

        const avatar = avatarUrl ? (
          <Avatar
            alt={label}
            src={avatarUrl}
            imgProps={{
              onError: (event) => ((event.target as HTMLElement).style.display = 'none'),
            }}
          />
        ) : (
          defaultAvatar
        );

        let props = chipProps;
        if (onDelete) {
          props = {
            onDelete: () => onDelete(value),
            ...props,
          };
        }
        if (onClick) {
          props = {
            onClick: () => onClick(value),
            ...props,
          };
        }

        return (
          <Chip
            key={`${value}_${uuidv4()}`}
            label={label}
            classes={{
              root: classes.chipRoot,
              label: classes.chipLabel,
            }}
            avatar={avatar}
            {...props}
          />
        );
      })}
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default ChipsField;
